<template>
  <sub-menu :links="links" :active="active"></sub-menu>
</template>

<script>
import Meta from '@/mixins/Meta'
import SubMenu from '@/components/Layout/SubMenu'

export default {
  components: {SubMenu},

  mixins: [Meta],

  props: ['company'],

  computed: {
    links() {
      return [
        {
          id: 'dashboard',
          url: '/companies/' + this.company.data.id,
          text: 'Dashboard'
        },
        {
          id: 'edit',
          url: '/companies/' + this.company.data.id + '/edit',
          text: 'Edit'
        },
        {
          id: 'people',
          url: '/companies/' + this.company.data.id + '/people',
          text: 'People'
        },
        {
          id: 'sales',
          text: 'Sales',
          links: [
            {
              url: '/companies/' + this.company.data.id + '/opportunities',
              text: 'Opportunities'
            },
            {
              url: '/companies/' + this.company.data.id + '/orders',
              text: 'Advertising'
            },
            {
              url: '/companies/' + this.company.data.id + '/subscriptions',
              text: 'Subscriptions'
            },
          ]
        },
        {
          id: 'order-confirmations',
          url: '/companies/' + this.company.data.id + '/order-confirmations',
          text: 'Order Confirmations'
        },
        {
          id: 'invoices',
          url: '/companies/' + this.company.data.id + '/invoices',
          text: 'Invoices'
        },
        {
          id: 'emails',
          url: '/companies/' + this.company.data.id + '/emails',
          text: 'Emails'
        },
        {
          id: 'portals',
          url: '/companies/' + this.company.data.id + '/portals',
          text: 'Portals'
        },
        {
          id: 'timeline',
          url: '/companies/' + this.company.data.id + '/timeline',
          text: 'Timeline'
        }
      ]
    },

    active() {
      return this.getMeta('subsection')
    }
  }
}
</script>
